import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'physical-evaluation',
        component: () => import('../views/PhysicalEvaluation')
    },
]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
